import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import CreateBankAccountForm from '../CreateBankAccountForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function CreateGroupListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`สร้างบัญชีธนาคาร`} description="สร้างบัญชีธนาคาร" />
				<NavigateBackButton />
			</div>
			<Separator />
			<CreateBankAccountForm />
		</div>
	)
}
